import axios from 'axios';
import { apiBaseUrl } from '../utils/urls';

const api = axios.create({
  baseURL: apiBaseUrl(),
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
  const isBlob = typeof Blob !== 'undefined' && config.data instanceof Blob;
  const isPlainObject = config.data
    && typeof config.data === 'object'
    && !Array.isArray(config.data)
    && !isFormData
    && !isBlob;

  if (isPlainObject) {
    config.headers['Content-Type'] = 'application/json';
    config.data = JSON.stringify(config.data);
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    const isTimeout = error?.code === 'ECONNABORTED' || error?.message?.includes('timeout');
    const hasNoHttpResponse = !error?.response;

    // لا تقم بإجبار المستخدم على الخروج عند فشل login نفسه
    const isLoginRequest = requestUrl.includes('/auth/login');

    // لا نعيد المحاولة تلقائيًا عند timeout حتى لا يتضاعف زمن الانتظار على المستخدم
    // (كان المستخدم ينتظر مهلة كاملة مرتين متتاليتين في حالات التعثر).

    if (status === 401 && !isLoginRequest) {
      localStorage.removeItem('token');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }

    if (isTimeout) {
      error.userMessage = 'الخادم استغرق وقتًا أطول من المتوقع. حاول مرة أخرى.';
    } else if (hasNoHttpResponse) {
      error.userMessage = 'تعذر الاتصال بالخادم (Network Error). تأكد أن خادم API يعمل وأن عنوان API صحيح.';
    }

    return Promise.reject(error);
  }
);

export default api;
